
import {
  defineComponent,
  computed,
  onMounted,
  useContext,
  useStore,
} from '@nuxtjs/composition-api'
import { getCountryCode } from '~/assets/ts/Locale'

export default defineComponent({
  components: {},
  setup() {
    const {
      app: { i18n },
    } = useContext()

    const scriptUrl = computed(() => {
      const country: string = getCountryCode()
      const language = i18n.locale || 'de'

      switch (country) {
        case 'us':
          return '/js/chat_us.js'
        case 'be':
          if (language === 'nl') {
            return '/js/chat_be-nl.js'
          } else {
            return '/js/chat_be-fr.js'
          }
        default:
          return ''
      }
    })

    const store = useStore()

    const areMarketingCookiesAllowed = computed(
      () => store.getters['cookieConsent/areMarketingCookiesAllowed']
    )

    onMounted(() => {
      const observer = new MutationObserver(
        (mutationsList, observerInstance) => {
          const iframe = document.getElementById(
            'superchat-widget-widget-button'
          )
          if (iframe) {
            iframe.setAttribute('title', 'Live-Chat')
            observerInstance.disconnect()
          }
        }
      )

      observer.observe(document.body, {
        childList: true,
        subtree: true,
      })
    })

    return {
      country: getCountryCode(),
      scriptUrl,
      areMarketingCookiesAllowed,
    }
  },
})
